import type { ComponentType } from 'react'
import type { AdminSection } from '../types'
import {
  Activity,
  Box,
  ChevronLeft,
  ClipboardList,
  CreditCard,
  Home,
  PackageOpen,
  Users,
} from './Icons'

const items: Array<{ section: AdminSection; label: string; icon: ComponentType<{ size?: number }> }> = [
  { section: 'overview', label: 'Overview', icon: Home },
  { section: 'customers', label: 'Customers', icon: Users },
  { section: 'entitlements', label: 'Entitlements', icon: ClipboardList },
  { section: 'activations', label: 'Activations', icon: Activity },
  { section: 'releases', label: 'Releases', icon: PackageOpen },
  { section: 'commerce', label: 'Commerce', icon: CreditCard },
  { section: 'audit-log', label: 'Audit log', icon: Box },
]

export function Sidebar({
  active,
  collapsed,
  onNavigate,
  onCollapse,
}: {
  active: AdminSection
  collapsed: boolean
  onNavigate: (section: AdminSection) => void
  onCollapse: () => void
}) {
  return (
    <aside className="sidebar">
      <div className="brand">
        <span className="brand-mark">C</span>
        <span>Curic Cloud</span>
      </div>
      <nav className="nav-list" aria-label="Primary navigation">
        {items.map(({ section, label, icon: Icon }) => (
          <button
            className={`nav-item ${section === active ? 'active' : ''}`}
            key={label}
            type="button"
            aria-current={section === active ? 'page' : undefined}
            aria-label={label}
            title={collapsed ? label : undefined}
            onClick={() => onNavigate(section)}
          >
            <Icon size={18} />
            <span>{label}</span>
          </button>
        ))}
      </nav>
      <button className="collapse-button" type="button" onClick={onCollapse} aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
        <ChevronLeft className={collapsed ? 'rotate-180' : ''} size={18} />
        Collapse
      </button>
    </aside>
  )
}
